import React, { useEffect, useState, useMemo } from 'react';
import {
  withRouter,
} from 'react-router-dom';
import { connect } from 'react-redux';
import {
  Card,
  Row,
  Col,
  Table,
  Input,
  Button,
  Icon,
  message,
  Spin,
} from 'antd';
import {
  ROLES,
  LYNX_CONNECT,
} from 'appconstants';
import RBAC from 'components/rbac';
import {
  SpButton,
  // SpH5,
} from 'components/DesignKit';
import debounce from 'lodash.debounce';
import { CSVLink } from 'react-csv';
import styled from 'styled-components';
import { lynxConnectActions, lynxTenantDetailActions } from 'store/actions';
import currencyformatter from 'utils/currencyformatter';
import exportIcon from 'imgs/export.svg';
import EditableCostInput from '../EditCost/EditableCostInput';
import InvoiceDetail from '../InvoiceDetail';
import ViewInvoice from '../ViewInvoice';

type Props = {
  // loading: boolean,
  test: boolean,
  // validator: Boolean,
  location: {
    pathname: string,
    search: string,
  },
  history: {
    push: Function,
  };
  selectedAccount: Object,
  // submitting: Boolean,
  lynxTenantDetails: Array,
  lynxConnectValidateItems: Array,
  lynxConnectValidateItemsTotalElements: Number,
  lyxnConnectEditRowSyncStatus: Object,
  fetchValidate: Function,
  validateUpdateAll: Function,
  validateEditRowSync: Function,
  // validateRowSync: Function,
  validateEditRowSyncStatus: Function,
  validateSetTableData: Function,
  resetValidateLineItems: Function,
  fetchLynxTenantDetails: Function,
  lynxConnectInvoiceDetail: {
    vendorName: String | null,
    invoiceNumber: String | null,
    totalAmount: Number | null,
    billedTo: String | null,
    invoiceDate: String | null,
    subTotalAmount: Number | null,
    fileName: String | null,
  },
  lynxConnectInvoicePdf: Object,
  // setInvoicePdf: Function,
  lynxConnectLoading: Boolean,
  fetchInvoicePdf: Function,
  fetchInvoiceDetail: Function,
  lynxConnectSubLoading: {
    invoiceDetail: Boolean,
    pdfData: Boolean,
  },
  setAuditEvent: Function,
  setValidateLineItemTotalElements: Function,
};

const SmallHeaderTable = styled.div`
  .ant-table-column-title {
    font-size: 14px;
    color: rgba(0, 0, 0, 0.7);
    padding: 0px;
  }
`;

const LynxConnectInvoiceLineItems = (props: Props) => {
  const {
    // loading,
    // validator,
    selectedAccount,
    // submitting,
    test,
    history,
    location,
    lynxTenantDetails,
    lynxConnectValidateItems,
    lynxConnectValidateItemsTotalElements,
    lyxnConnectEditRowSyncStatus,
    fetchValidate,
    validateUpdateAll,
    validateEditRowSync,
    // validateRowSync,
    validateEditRowSyncStatus,
    validateSetTableData,
    resetValidateLineItems,
    fetchLynxTenantDetails,
    lynxConnectInvoiceDetail,
    lynxConnectInvoicePdf,
    // setInvoicePdf,
    lynxConnectLoading,
    lynxConnectSubLoading,
    fetchInvoicePdf,
    fetchInvoiceDetail,
    setAuditEvent,
    setValidateLineItemTotalElements,
  } = props;

  // to reset the state of validate line items on
  // page load.
  useEffect(() => {
    resetValidateLineItems({});
    // get the lynx tentant details
    fetchLynxTenantDetails();
    // fetch the invoice and pdf details
    if (/^\/lynxconnect\/invoices\/validate\/[^/]+$/.test(location.pathname)) {
      const invoiceGid = location.pathname.split('/').slice(-1)[0];
      fetchInvoiceDetail({
        gid: invoiceGid,
      });
      fetchInvoicePdf({
        gid: invoiceGid,
      });
    }
  }, []);

  const [isEditing, setIsEditing] = useState(false);
  const [tableFieldValue, setTableFieldValue] = useState({});
  const [csvFileName, setCsvFileName] = useState('Validate_Line_Items.csv');
  const [showPdfCard, setShowPdfCard] = useState(false);

  const debouncedUpdateAll = useMemo(() => (
    debounce(validateUpdateAll, 2000, { leading: true })
  ), [validateUpdateAll]);

  const debouncedEditModeRowSync = useMemo(() => (
    debounce(validateEditRowSync, 1000, { leading: true })
  ), [validateEditRowSync]);

  // const debouncedRowSync = useMemo(() => (
  //   debounce(validateRowSync, 2000, { leading: true })
  // ), [validateRowSync]);

  const fileExportHeaders = useMemo(() => ([
    { label: 'ITEM NAME', key: 'itemName' },
    { label: 'SKU', key: 'barcode' },
    { label: 'ITEM CODE', key: 'itemCode' },
    { label: 'VENDOR ITEM CODE', key: 'vendorItemCode' },
    { label: 'UNIT QUANTITY', key: 'quantity' },
    { label: 'UNIT', key: 'unit' },
    { label: 'CASE COST', key: 'caseCost' },
    { label: 'CASE QUANTITY', key: 'caseQuantity' },
    { label: 'CASE ITEM QUANTITY', key: 'caseItemQuantity' },
    { label: 'TOTAL ITEM QUANTITY', key: 'totalCaseItemQuantity' },
    { label: 'ITEM PRICE', key: 'price' },
    { label: 'TOTAL COST', key: 'totalCost' },
    { label: 'DESCRIPTION', key: 'description' },
    { label: 'HAND WRITTEN', key: 'handWritten' },
  ]), []);

  const fileExportData = useMemo(() => {
    const presetCurrencyFromatter = (value) => currencyformatter(Number(value / 100), selectedAccount?.currency?.name);
    return lynxConnectValidateItems.map((item) => ({
      itemName: item.itemName,
      barcode: item.barcode,
      itemCode: item.sku,
      vendorItemCode: item.vendorItemCode,
      quantity: item.quantity, // confirm
      unit: item.unit,
      caseCost: presetCurrencyFromatter(item.caseCost),
      caseQuantity: item.caseQuantity,
      caseItemQuantity: item.caseItemQuantity,
      totalCaseItemQuantity: item.totalCaseItemQuantity,
      price: presetCurrencyFromatter(item.unitCost), // item cost
      totalCost: presetCurrencyFromatter(item.totalCost),
      description: item.description,
      handWritten: item.handWritten,
    }));
  }, [lynxConnectValidateItems, selectedAccount]);

  useEffect(() => {
    if (!/^\/lynxconnect\/invoices\/validate\/[^/]+$/.test(location.pathname)) {
      return;
    }
    setCsvFileName(`Validate_Line_Items_${location.pathname.split('/').slice(-1)[0]}.csv`);
  }, [lynxConnectValidateItems]);

  const handleCsvFileDownload = (e) => {
    if (fileExportData.length === 0) {
      message.error('No Data to Export!');
      e.preventDefault();
    } else {
      message.success('Starting Download...');
      if (/^\/lynxconnect\/invoices\/validate\/[^/]+$/.test(location.pathname)) {
        setAuditEvent({
          gid: location.pathname.split('/').slice(-1)[0],
          payload: {
            eventHeader: 'Item Exported',
            eventOrigin: 'Validate New Items',
          },
        });
      }
    }
  };

  const getData = (query) => {
    fetchValidate({
      gid: query,
    });
  };

  useEffect(() => {
    if (!/^\/lynxconnect\/invoices\/validate\/[^/]+$/.test(location.pathname)) {
      return;
    }
    getData(location.pathname.split('/').slice(-1)[0]);
  }, [location, test, selectedAccount]);

  const handleTableFieldEdit = (lineItemGid, columnName, value) => {
    let processedValue = value;
    if (LYNX_CONNECT.INTEGER_FIELDS.includes(columnName)) {
      processedValue = !Number.isNaN(parseInt(value, 10)) ? parseInt(value, 10) : '';
    }
    setTableFieldValue(state => {
      const newState = { ...state };
      newState[lineItemGid] = {
        ...state[lineItemGid],
        [columnName]: processedValue,
      };
      return newState;
    });
  };

  const commitChange = (lineItemGid, columnName, value) => {
    let parsedValue = '';
    if (!Number.isNaN(parseInt(value, 10))) {
      parsedValue = parseInt(value, 10);
    } else {
      parsedValue = 0;
    }
    setTableFieldValue(state => {
      const newState = { ...state };
      newState[lineItemGid] = {
        ...state[lineItemGid],
        [columnName]: parsedValue,
      };
      return newState;
    });
  };

  const handleEditModeRowSync = (lineItemGid) => {
    // call the api and on success reponse
    if (!/^\/lynxconnect\/invoices\/validate\/[^/]+$/.test(location.pathname)) {
      return;
    }
    const lineItemValues = tableFieldValue[lineItemGid];
    const payload = {
      name: lineItemValues.itemName.trim(),
      barcode: lineItemValues.barcode.trim(),
      sku: lineItemValues.sku.trim(), // was itemCode
      itemCode: lineItemValues.vendorItemCode.trim(), // this uses itemCode now
      quantity: lineItemValues.quantity, // confirm
      unit: lineItemValues.unit.trim(),
      caseCost: lineItemValues.caseCost,
      caseQuantity: lineItemValues.caseQuantity,
      itemQuantityPerCase: lineItemValues.caseItemQuantity,
      totalItemQuantity: lineItemValues.totalCaseItemQuantity,
      price: lineItemValues.unitCost, // item cost
      totalCost: lineItemValues.totalCost,
      description: lineItemValues.description.trim(),
      handWritten: lineItemValues.handWritten.trim(),
    };
    debouncedEditModeRowSync({
      invoiceGid: location.pathname.split('/').slice(-1)[0],
      lineItemGid,
      payload,
    });
  };

  // remove the synced row from the table if the
  // status changes to match
  useEffect(() => {
    if (lyxnConnectEditRowSyncStatus
      && lyxnConnectEditRowSyncStatus.status === 'Success'
      && lyxnConnectEditRowSyncStatus.syncStatus === 'MATCH'
    ) {
      // remove the row from editable table
      const tableValues = {
        ...tableFieldValue,
      };
      delete tableValues[lyxnConnectEditRowSyncStatus.lineItemId];
      setTableFieldValue(tableValues);
      // reset the status
      validateEditRowSyncStatus({
        status: '',
        lineItemId: null,
        syncStatus: null,
      });
      // change the table data too
      validateSetTableData(lynxConnectValidateItems.filter(record => (
        record.gid !== lyxnConnectEditRowSyncStatus.lineItemId
      )));
      // set the total number of elements
      setValidateLineItemTotalElements(lynxConnectValidateItemsTotalElements - 1);
    }
  }, [lyxnConnectEditRowSyncStatus]);

  // change mode to non-editable; if the table
  // has no data
  useEffect(() => {
    if (Array.isArray(lynxConnectValidateItems)
    && lynxConnectValidateItems.length === 0
    ) {
      setIsEditing(false);
    }
  }, [isEditing, lynxConnectValidateItems]);

  // const handleRowSync = (lineItemGid) => {
  //   // call the api to change them to existing item
  //   debouncedRowSync({
  //     gid: lineItemGid,
  //   });
  //   // on success response remove item from table data value
  //   // this is be done through a fetch all validate line items acton
  // };

  const handleReviewExistingItemButton = () => {
    // this button causes a history push, triggering the loading
    // of another component
    if (!/^\/lynxconnect\/invoices\/validate\/[^/]+$/.test(location.pathname)) {
      return;
    }
    const reviewExistingItemGid = location.pathname.split('/').slice(-1)[0];
    history.push(`/lynxconnect/invoices/exist/${reviewExistingItemGid}`);
  };

  const handleEdit = () => {
    // create the input state object with
    // table data
    if (!Array.isArray(lynxConnectValidateItems)
      || lynxConnectValidateItems.length === 0
    ) {
      message.error('No Data to Edit.');
      return;
    }
    const tableValue = {};
    lynxConnectValidateItems.forEach((item) => {
      tableValue[item.gid] = {
        gid: String(item.gid),
        itemName: String(item.itemName ?? ''),
        barcode: item.barcode.trim(),
        sku: String(item.sku ?? ''),
        vendorItemCode: String(item.vendorItemCode ?? ''),
        quantity: Number(item.quantity ?? 0), // confirm
        unit: String(item.unit ?? ''),
        caseCost: Number(item.caseCost ?? 0),
        caseQuantity: Number(item.caseQuantity ?? 0),
        caseItemQuantity: Number(item.caseItemQuantity ?? 0),
        totalCaseItemQuantity: Number(item.totalCaseItemQuantity ?? 0),
        unitCost: Number(item.unitCost ?? 0), // item cost
        totalCost: Number(item.totalCost ?? 0),
        description: String(item.description ?? ''),
        handWritten: String(item.handWritten ?? ''),
      };
    });
    setTableFieldValue(tableValue);
    // set editing as true
    setIsEditing(true);
  };

  const handleSave = () => {
    // call api and pass the tableFieldValue state as input
    if (!/^\/lynxconnect\/invoices\/validate\/[^/]+$/.test(location.pathname)) {
      return;
    }
    const payload = {
      lineItems: Object.values(tableFieldValue).map((item) => ({
        lineItemId: item.gid,
        name: item.itemName.trim(),
        barcode: item.barcode.trim(),
        sku: item.sku.trim(), // changed from itemCode to sku
        itemCode: item.vendorItemCode.trim(),
        quantity: item.quantity, // confirm
        unit: item.unit.trim(),
        caseCost: item.caseCost,
        caseQuantity: item.caseQuantity,
        itemQuantityPerCase: item.caseItemQuantity,
        totalItemQuantity: item.totalCaseItemQuantity,
        price: item.unitCost, // item cost
        totalCost: item.totalCost,
        description: item.description.trim(),
        handWritten: item.handWritten.trim(),
      })),
    };
    debouncedUpdateAll({
      gid: location.pathname.split('/').slice(-1)[0],
      payload,
    });
    // set editing as false
    setIsEditing(false);
  };

  const handleCancel = () => {
    if (isEditing) {
      if (/^\/lynxconnect\/invoices\/validate\/[^/]+$/.test(location.pathname)) {
        getData(location.pathname.split('/').slice(-1)[0]);
      }
      // set the editing field values to empty object
      setTableFieldValue({});
      // set the editing state to false
      setIsEditing(false);
    }
  };

  const columns = [
    {
      title: 'ITEM NAME',
      dataIndex: 'itemName',
      width: '150px',
      align: 'left',
      // sorter: true,
      // sortDirections: ['ascend', 'descend', 'ascend'],
      render: (text, record) => (
        isEditing ? (
          <Input
            value={tableFieldValue[record.gid]?.['itemName'] ?? ''}
            onChange={(e) => handleTableFieldEdit(record.gid, 'itemName', e.target.value)}
          />
        ) : (
          <span style={{ cursor: 'pointer' }}>
            {text || <>&#8211;</>}
          </span>
        )
      ),
    },
    {
      title: 'BARCODE',
      dataIndex: 'barcode',
      width: '150px',
      align: 'left',
      // sorter: true,
      // sortDirections: ['ascend', 'descend', 'ascend'],
      render: (text, record) => (
        isEditing ? (
          <Input
            value={tableFieldValue[record.gid]?.['barcode'] ?? ''}
            onChange={(e) => handleTableFieldEdit(record.gid, 'barcode', e.target.value)}
          />
        ) : (
          <span style={{ cursor: 'pointer' }}>
            {text || <>&#8211;</>}
          </span>
        )
      ),
    },
    {
      title: 'SKU',
      dataIndex: 'sku',
      width: '150px',
      align: 'left',
      // sorter: true,
      // sortDirections: ['ascend', 'descend', 'ascend'],
      render: (text, record) => (
        isEditing ? (
          <Input
            value={tableFieldValue[record.gid]?.['sku'] ?? ''}
            onChange={(e) => handleTableFieldEdit(record.gid, 'sku', e.target.value)}
          />
        ) : (
          <span style={{ cursor: 'pointer' }}>
            {text || <>&#8211;</>}
          </span>
        )
      ),
    },
    {
      title: 'VENDOR ITEM CODE',
      dataIndex: 'vendorItemCode',
      width: '150px',
      align: 'left',
      // sorter: true,
      // sortDirections: ['ascend', 'descend', 'ascend'],
      render: (text, record) => (
        isEditing ? (
          <Input
            value={tableFieldValue[record.gid]?.['vendorItemCode'] ?? ''}
            onChange={(e) => handleTableFieldEdit(record.gid, 'vendorItemCode', e.target.value)}
          />
        ) : (
          <span style={{ cursor: 'pointer' }}>
            {text || <>&#8211;</>}
          </span>
        )
      ),
    },
    {
      title: 'UNIT QUANTITY',
      dataIndex: 'quantity',
      width: '150px',
      align: 'left',
      // sorter: true,
      // sortDirections: ['ascend', 'descend', 'ascend'],
      render: (text, record) => (
        isEditing ? (
          <Input
            value={tableFieldValue[record.gid]?.['quantity'] ?? ''}
            onChange={(e) => handleTableFieldEdit(record.gid, 'quantity', e.target.value)}
            onBlur={(e) => commitChange(record.gid, 'quantity', e.target.value)}
          />
        ) : (
          <span style={{ cursor: 'pointer' }}>
            {text || <>&#8211;</>}
          </span>
        )
      ),
    },
    {
      title: 'UNIT',
      dataIndex: 'unit',
      width: '150px',
      align: 'left',
      // sorter: true,
      // sortDirections: ['ascend', 'descend', 'ascend'],
      render: (text, record) => (
        isEditing ? (
          <Input
            value={tableFieldValue[record.gid]?.['unit'] ?? ''}
            onChange={(e) => handleTableFieldEdit(record.gid, 'unit', e.target.value)}
          />
        ) : (
          <span style={{ cursor: 'pointer' }}>
            {text || <>&#8211;</>}
          </span>
        )
      ),
    },
    {
      title: 'CASE COST',
      dataIndex: 'caseCost',
      width: '150px',
      align: 'left',
      // sorter: true,
      // sortDirections: ['ascend', 'descend', 'ascend'],
      render: (text, record) => (
        isEditing ? (
          <div style={{
            display: 'flex',
            flexWrap: 'nowrap',
            flexDirection: 'row',
            alignContent: 'center',
            justifyContent: 'center',
          }}
          >
            {/* <span>{selectedAccount.currency.prefix}</span> */}
            <EditableCostInput
              valueInCents={tableFieldValue[record.gid]?.['caseCost']}
              onChange={(newCents) => handleTableFieldEdit(record.gid, 'caseCost', newCents)}
              currencyPrefix={selectedAccount.currency.prefix}
            />
          </div>
        ) : (
          <span style={{ cursor: 'pointer' }}>
            {currencyformatter(Number(text) / 100, selectedAccount.currency.name) || <>&#8211;</>}
          </span>
        )
      ),
    },
    {
      title: 'CASE QUANTITY',
      dataIndex: 'caseQuantity',
      width: '150px',
      align: 'left',
      // sorter: true,
      // sortDirections: ['ascend', 'descend', 'ascend'],
      render: (text, record) => (
        isEditing ? (
          <Input
            value={tableFieldValue[record.gid]?.['caseQuantity'] ?? ''}
            onChange={(e) => handleTableFieldEdit(record.gid, 'caseQuantity', e.target.value)}
            onBlur={(e) => commitChange(record.gid, 'caseQuantity', e.target.value)}
          />
        ) : (
          <span style={{ cursor: 'pointer' }}>
            {text || <>&#8211;</>}
          </span>
        )
      ),
    },
    {
      title: 'ITEM QUANTITY PER CASE',
      dataIndex: 'caseItemQuantity',
      width: '150px',
      align: 'left',
      // sorter: true,
      // sortDirections: ['ascend', 'descend', 'ascend'],
      render: (text, record) => (
        isEditing ? (
          <Input
            value={tableFieldValue[record.gid]?.['caseItemQuantity'] ?? ''}
            onChange={(e) => handleTableFieldEdit(record.gid, 'caseItemQuantity', e.target.value)}
            onBlur={(e) => commitChange(record.gid, 'caseItemQuantity', e.target.value)}
          />
        ) : (
          <span style={{ cursor: 'pointer' }}>
            {text || <>&#8211;</>}
          </span>
        )
      ),
    },
    {
      title: 'TOTAL ITEM QUANTITY',
      dataIndex: 'totalCaseItemQuantity',
      width: '150px',
      align: 'left',
      // sorter: true,
      // sortDirections: ['ascend', 'descend', 'ascend'],
      render: (text, record) => (
        isEditing ? (
          <Input
            value={tableFieldValue[record.gid]?.['totalCaseItemQuantity'] ?? ''}
            onChange={(e) => handleTableFieldEdit(record.gid, 'totalCaseItemQuantity', e.target.value)}
            onBlur={(e) => commitChange(record.gid, 'totalCaseItemQuantity', e.target.value)}
          />
        ) : (
          <span style={{ cursor: 'pointer' }}>
            {text || <>&#8211;</>}
          </span>
        )
      ),
    },
    {
      title: 'ITEM COST',
      dataIndex: 'unitCost',
      width: '150px',
      align: 'left',
      // sorter: true,
      // sortDirections: ['ascend', 'descend', 'ascend'],
      render: (text, record) => (
        isEditing ? (
          <div style={{
            display: 'flex',
            flexWrap: 'nowrap',
            flexDirection: 'row',
            alignContent: 'center',
            justifyContent: 'center',
          }}
          >
            {/* <span>{selectedAccount.currency.prefix}</span> */}
            <EditableCostInput
              valueInCents={tableFieldValue[record.gid]?.['unitCost']}
              onChange={(newCents) => handleTableFieldEdit(record.gid, 'unitCost', newCents)}
              currencyPrefix={selectedAccount.currency.prefix}
            />
          </div>
        ) : (
          <span style={{ cursor: 'pointer' }}>
            {currencyformatter(Number(text) / 100, selectedAccount.currency.name) || <>&#8211;</>}
          </span>
        )
      ),
    },
    {
      title: 'TOTAL COST',
      dataIndex: 'totalCost',
      width: '150px',
      align: 'left',
      // sorter: true,
      // sortDirections: ['ascend', 'descend', 'ascend'],
      render: (text, record) => (
        isEditing ? (
          <div style={{
            display: 'flex',
            flexWrap: 'nowrap',
            flexDirection: 'row',
            alignContent: 'center',
            justifyContent: 'center',
          }}
          >
            {/* <span>{selectedAccount.currency.prefix}</span> */}
            <EditableCostInput
              valueInCents={tableFieldValue[record.gid]?.['totalCost']}
              onChange={(newCents) => handleTableFieldEdit(record.gid, 'totalCost', newCents)}
              currencyPrefix={selectedAccount.currency.prefix}
            />
          </div>
        ) : (
          <span style={{ cursor: 'pointer' }}>
            {currencyformatter(Number(text) / 100, selectedAccount.currency.name) || <>&#8211;</>}
          </span>
        )
      ),
    },
    {
      title: 'DESCRIPTION',
      dataIndex: 'description',
      width: '180px',
      align: 'left',
      // sorter: true,
      // sortDirections: ['ascend', 'descend', 'ascend'],
      render: (text, record) => (
        isEditing ? (
          <Input
            value={tableFieldValue[record.gid]?.['description'] ?? ''}
            onChange={(e) => handleTableFieldEdit(record.gid, 'description', e.target.value)}
          />
        ) : (
          <span style={{ cursor: 'pointer' }}>
            {text || <>&#8211;</>}
          </span>
        )
      ),
    },
    {
      title: 'HAND WRITTEN',
      dataIndex: 'handWritten',
      width: '180px',
      align: 'left',
      // sorter: true,
      // sortDirections: ['ascend', 'descend', 'ascend'],
      render: (text, record) => (
        isEditing ? (
          <Input
            value={tableFieldValue[record.gid]?.['handWritten'] ?? ''}
            onChange={(e) => handleTableFieldEdit(record.gid, 'handWritten', e.target.value)}
          />
        ) : (
          <span style={{ cursor: 'pointer' }}>
            {text || <>&#8211;</>}
          </span>
        )
      ),
    },
    {
      title: 'Action',
      dataIndex: 'action',
      width: '100px',
      align: 'left',
      // sorter: true,
      // sortDirections: ['ascend', 'descend', 'ascend'],
      render: (text, record) => (
        isEditing ? (
          <Button
            onClick={() => handleEditModeRowSync(record.gid)}
          >
            <Icon type="sync" />
          </Button>
        ) : (
          <Button
            // onClick={() => handleRowSync(record.gid)}
            disabled
          >
            <Icon type="sync" />
          </Button>
        )
      ),
    },
  ];

  if (!Array.isArray(lynxTenantDetails)
    || lynxTenantDetails.length === 0
    || (lynxConnectInvoiceDetail?.status !== LYNX_CONNECT.INVOICE_STATUS.READY_TO_PROCESS
      && lynxConnectInvoiceDetail?.status !== LYNX_CONNECT.INVOICE_STATUS.WAITING_FOR_APPROVAL
    )
  ) {
    return <></>;
  }

  return (
    <Card>
      <RBAC permit={
        [ROLES.ADMINISTRATOR,
          ROLES.OWNER,
          ROLES.DEVELOPER,
          ROLES.OPERATIONS,
          // ROLES.ANALYST,
          ROLES.SUPPORT,
          ROLES.INTERNALSUPPORT,
          ROLES.POS,
          ROLES.SUPERUSER,
          ROLES.ONBOARDING,
          ROLES.OFFICEMANAGER,
          ROLES.OFFICESUPPORT,
          ROLES.WAREHOUSE_ASSOCIATE,
          ROLES.PRICING_ANALYST,
        ]
            }
      >
        <Spin
          spinning={lynxConnectLoading}
          tip="Please wait..."
          size="large"
          delay={300} // delay in ms to avoid flicker
        >
          <Row type="flex" justify="end" className="mt-2">
            <Col>
              {
                isEditing ? (
                  <SpButton
                    type="primary"
                    shape="round"
                    className="mr-3"
                    ghost
                    onClick={handleSave}
                  >
                    Save
                  </SpButton>
                ) : (
                  <SpButton
                    type="primary"
                    shape="round"
                    className="mr-3"
                    ghost
                    onClick={handleEdit}
                    disabled={lynxConnectInvoiceDetail?.status !== LYNX_CONNECT.INVOICE_STATUS.READY_TO_PROCESS}
                  >
                    Edit
                  </SpButton>
                )
              }
            </Col>
            {
              !isEditing && (
              <Col>
                <SpButton
                  type="secondary"
                  shape="round"
                  className="mr-3"
                  ghost
                  onClick={handleReviewExistingItemButton}
                >
                  Review Existing Items
                </SpButton>
              </Col>
              )
            }
            {
              isEditing && (
                <Col>
                  <SpButton
                    type="dangerSecondary"
                    shape="round"
                    className="mr-3"
                    ghost
                    onClick={handleCancel}
                  >
                    Cancel
                  </SpButton>
                </Col>
              )
            }
            { !isEditing && (
              <Col style={{ display: 'flex', justifyContent: 'center', marginRight: '20px' }}>
                <CSVLink
                  data={fileExportData}
                  headers={fileExportHeaders}
                  filename={csvFileName}
                  className="mt-1"
                  onClick={handleCsvFileDownload}
                >
                  <img src={exportIcon} alt="Export as CSV" />
                </CSVLink>
              </Col>
            )}
          </Row>
          <Spin
            spinning={lynxConnectLoading
              ? false
              : lynxConnectSubLoading.invoiceDetail}
            tip="Please wait..."
            size="large"
            delay={300} // delay in ms to avoid flicker
          >
            <Row
              gutter={16}
              className="mt-3 mr-3 ml-3"
            >
              <Col span={24}>
                <InvoiceDetail
                  selectedAccount={selectedAccount}
                  invoiceDetail={{
                    vendorName: lynxConnectInvoiceDetail?.vendorName ?? '',
                    invoiceNumber: lynxConnectInvoiceDetail?.invoiceNumber ?? '',
                    totalAmount: lynxConnectInvoiceDetail?.totalAmount ?? '',
                    billedTo: lynxConnectInvoiceDetail?.billedTo ?? '',
                    invoiceDate: lynxConnectInvoiceDetail?.invoiceDate ?? '',
                    subTotalAmount: lynxConnectInvoiceDetail?.subTotalAmount ?? '',
                  }}
                />
              </Col>
            </Row>
          </Spin>
          <Row>
            <ViewInvoice
              pdfData={lynxConnectInvoicePdf ?? new ArrayBuffer('')}
              pdfName={lynxConnectInvoiceDetail?.fileName ?? ''}
              showPdfCard={showPdfCard}
              setShowPdfCard={setShowPdfCard}
              loading={lynxConnectSubLoading.pdfData}
            />
          </Row>
          <Row>
            <SmallHeaderTable>
              <Table
                columns={columns}
                rowKey={(record) => record.gid}
                dataSource={lynxConnectValidateItems}
                pagination={false}
                scroll={{ x: 400, y: 500 }}
                style={{ margin: '20px' }}
              />
            </SmallHeaderTable>
          </Row>
          <Row
            type="flex"
            align="middle"
            style={{
              backgroundColor: '#f5f5f5', // light gray
              padding: '10px 16px',
              borderRadius: '4px',
              marginBottom: '16px',
            }}
          >
            <Col>
              <h6 style={{ fontWeight: 'bold', margin: 0 }}>
                Total New Items Listed: {lynxConnectValidateItemsTotalElements}
              </h6>
            </Col>
          </Row>
        </Spin>
      </RBAC>
    </Card>
  );
};

const mapStateToProps = state => ({
  loading: state.loading.loading,
  validator: state.loading.validator,
  selectedAccount: state.account.selectedAccount,
  submitting: state.loading.submitting,
  test: state.account.test,
  lynxTenantDetails: state.lynxTenantDetails.lynxTenantDetails,
  lynxConnectValidateItems: state.lynxConnect.validate.content,
  lynxConnectValidateItemsTotalElements: state.lynxConnect.validate.totalElements,
  lyxnConnectEditRowSyncStatus: state.lynxConnect.validate.editRowSyncStatus,
  lynxConnectInvoiceDetail: state.lynxConnect.invoices.invoiceDetail,
  lynxConnectInvoicePdf: state.lynxConnect.pdf,
  lynxConnectLoading: state.lynxConnect.loading,
  lynxConnectSubLoading: state.lynxConnect.subLoading,
});

const mapDispatchToProps = dispatch => ({
  fetchValidate: param => dispatch(lynxConnectActions.fetchValidate({
    payload: param,
  })),
  validateUpdateAll: param => dispatch(lynxConnectActions.validateUpdateAll({
    payload: param,
  })),
  validateEditRowSync: param => dispatch(lynxConnectActions.validateEditRowSync({
    payload: param,
  })),
  validateRowSync: param => dispatch(lynxConnectActions.validateRowSync({
    payload: param,
  })),
  validateEditRowSyncStatus: param => dispatch(lynxConnectActions.validateEditRowSyncStatus({
    payload: param,
  })),
  validateSetTableData: param => dispatch(lynxConnectActions.validateSetTableData({
    payload: param,
  })),
  resetValidateLineItems: param => dispatch(lynxConnectActions.resetValidateLineItems({
    payload: param,
  })),
  fetchLynxTenantDetails: param => dispatch(lynxTenantDetailActions.fetchLynxTenantDetails({
    payload: param,
  })),
  setInvoicePdf: param => dispatch(lynxConnectActions.setInvoicePdf({
    payload: param,
  })),
  fetchInvoiceDetail: param => dispatch(lynxConnectActions.fetchInvoiceDetail({
    payload: param,
  })),
  fetchInvoicePdf: param => dispatch(lynxConnectActions.fetchInvoicePdf({
    payload: param,
  })),
  setAuditEvent: param => dispatch(lynxConnectActions.setAuditEvent({
    payload: param,
  })),
  setValidateLineItemTotalElements: param => dispatch(lynxConnectActions.setValidateLineItemTotalElements({
    payload: param,
  })),
});

// $FlowFixMe
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(LynxConnectInvoiceLineItems));
